var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWip1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 258,
    viewBox: "0 0 394 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3274_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4625 237.057H89.2671V240.936H41.4625V237.057Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4172 228.366C44.8194 227.131 45.9708 226.295 47.2698 226.295H83.5847C84.8838 226.295 86.0352 227.131 86.4374 228.366L89.267 237.057H41.5876L44.4172 228.366Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6957 72.1187V86.7604H163.602L150.337 73.3701L26.6957 72.1187Z",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.409 86.7603V73.3701L119.677 86.7603V73.3701L135.069 86.7603V73.3701L150.337 86.7603V73.8706V73.3701",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0894 86.7603V72.3689",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0165 73.3701V86.7603L73.7491 73.3701",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7495 73.3701V86.7603",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2308 220.037H73.6245V58.478L65.3651 50.8442L57.2308 58.478V220.037Z",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 59.3541H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 100.651H57.2308",
    stroke: "#E7EBF2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 113.916H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 127.057H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 140.322H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 153.587H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 166.852H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 179.992H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 193.257H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6245 206.522H57.2308",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.198 73.2448L65.365 50.8442L30.7004 72.2437",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7495 86.7601L57.2307 72.619",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 87.261L73.249 100.151",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7312 59.6044L73.374 72.1187",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5901 72.619L56.605 86.5098",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7139 86.5098L26.8207 72.619",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5177 73.2448L103.909 86.1345",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8564 101.027L73.249 113.416",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8564 114.417L73.249 126.556",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 127.557L73.249 139.821",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 140.947L73.249 153.086",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 154.087L73.249 166.226",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 167.227L73.249 179.491",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 180.493L73.249 192.757",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 193.758L73.249 206.022",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7313 207.148L73.249 219.287",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.72 219.912H81.0103C82.1148 219.912 83.0103 220.808 83.0103 221.912V226.295H47.72V221.912C47.72 220.808 48.6154 219.912 49.72 219.912Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5197 98.8993L82.134 108.285C81.5083 108.911 80.6323 109.286 79.8814 109.286H56.3546V87.261H92.646V96.5216C92.3957 97.5228 92.1454 98.2736 91.5197 98.8993Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1381 97.2587H61.1255C60.5732 97.2587 60.1255 96.811 60.1255 96.2587V91.8764C60.1255 91.3241 60.5732 90.8764 61.1255 90.8764H70.138C70.6903 90.8764 71.138 91.3241 71.138 91.8764V96.2587C71.138 96.811 70.6903 97.2587 70.1381 97.2587Z",
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3744 97.2584H75.3618C74.8095 97.2584 74.3618 96.8107 74.3618 96.2584V91.8761C74.3618 91.3238 74.8095 90.8761 75.3618 90.8761H84.3744C84.9267 90.8761 85.3744 91.3238 85.3744 91.8761V96.2584C85.3744 96.8107 84.9267 97.2584 84.3744 97.2584Z",
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1495 201.811H24.2427V241.857H29.1495V201.811Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9717 201.811H59.0649V241.857H63.9717V201.811Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.124 240.432C198.828 240.749 183 240.432 171.762 240.274C160.524 240.59 144.696 240.749 131.4 240.432C144.537 232.993 148.969 219.222 149.761 210.042H193.605C194.555 219.222 198.987 232.993 212.124 240.432Z",
    fill: "url(#paint0_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.228 94.8117V208.617C254.228 211.466 252.012 213.524 249.321 213.524H94.2037C91.5128 213.524 89.2969 211.308 89.2969 208.617V94.8117C89.2969 92.1209 91.5128 89.9049 94.2037 89.9049H249.321C252.012 89.9049 254.228 91.9626 254.228 94.8117Z",
    fill: "url(#paint1_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.228 94.8117V192.947H89.4551V94.8117C89.4551 92.1209 91.671 89.9049 94.3619 89.9049H249.479C252.012 89.9049 254.228 91.9626 254.228 94.8117Z",
    fill: "#262A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.371 95.9193H95.3115V187.249H248.213V95.9193H248.371Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.762 207.192C174.035 207.192 175.878 205.35 175.878 203.077C175.878 200.804 174.035 198.962 171.762 198.962C169.489 198.962 167.647 200.804 167.647 203.077C167.647 205.35 169.489 207.192 171.762 207.192Z",
    fill: "#262A31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.717 206.243H340.444V241.382H344.717V206.243Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.266 206.243H370.992V241.382H375.266V206.243Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.648 207.826H335.695V222.23H380.648V207.826Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.617 207.826L341.868 222.23H336.487L341.077 207.826H346.617Z",
    fill: "url(#paint2_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.538 207.826L352.79 222.23H347.408L351.998 207.826H357.538Z",
    fill: "url(#paint3_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.46 207.826L363.711 222.23H358.33L362.92 207.826H368.46Z",
    fill: "url(#paint4_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.381 207.826L374.633 222.23H369.251L373.841 207.826H379.381Z",
    fill: "url(#paint5_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1446 203.71H18.8608V220.172H70.1446V203.71Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.207 203.71L25.8254 220.014H19.6523L25.034 203.71H31.207Z",
    fill: "url(#paint6_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7114 203.71L38.3298 220.014H32.1567L37.3801 203.71H43.7114Z",
    fill: "url(#paint7_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2158 203.71L50.8342 220.014H44.6611L49.8845 203.71H56.2158Z",
    fill: "url(#paint8_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7202 203.71L63.3386 220.014H57.1655L62.3889 203.71H68.7202Z",
    fill: "url(#paint9_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.864 45.7441V65.0547",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.943 73.4436C195.047 73.4436 197.562 70.9279 197.562 67.8245C197.562 64.7212 195.047 62.2055 191.943 62.2055C188.84 62.2055 186.324 64.7212 186.324 67.8245C186.324 70.9279 188.84 73.4436 191.943 73.4436Z",
    fill: "#3D4550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.482 82.7823C186.482 86.2645 189.648 89.1136 193.447 88.1639C195.505 87.6891 197.087 86.1063 197.562 84.0486C198.195 81.0412 196.454 78.1921 193.763 77.4007C192.814 77.0841 192.181 76.2927 192.181 75.1847V70.278",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.621 236.633H268.157V241.54H328.621V236.633Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.705 225.092C324.303 223.857 323.151 223.021 321.852 223.021H274.767C273.468 223.021 272.316 223.857 271.914 225.092L268.157 236.633H328.463L324.705 225.092Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.298 28.0159V46.535H174.137L190.915 29.5987L347.298 28.0159Z",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.004 46.535V29.5987L229.694 46.535V29.5987L210.225 46.535V29.5987L190.915 46.535V30.2318V29.5987",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.563 46.5351V28.3325",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.474 29.5987V46.535L287.784 29.5987",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.784 29.5987V46.535",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.677 215.107H287.942V10.7631L298.389 1.10779L308.677 10.7631V215.107Z",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 11.8712H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 64.1046H308.677",
    stroke: "#BBC1CF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 80.8821H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 97.5021H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 114.28H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 131.058H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 147.836H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 164.456H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 181.234H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.942 198.012H308.677",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.268 29.4405L298.389 1.10779L342.233 28.1742",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.784 46.5348L308.678 28.6488",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 47.1683L288.417 63.4714",
    stroke: "#BBC1CF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 12.1876L288.259 28.0159",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.93 28.6488L309.469 46.2182",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.038 46.2182L347.14 28.6488",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.84 29.4402L249.638 45.7434",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.886 64.5794L288.417 80.2494",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.886 81.5157L288.417 96.8691",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 98.1354L288.417 113.647",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 115.072L288.417 130.425",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 131.691L288.417 147.045",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 148.311L288.417 163.823",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 165.089L288.417 180.601",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 181.867L288.417 197.379",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.044 198.803L288.417 214.157",
    stroke: "#3D4550",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.707 214.948H278.071C276.966 214.948 276.071 215.844 276.071 216.948V223.021H320.707V216.948C320.707 215.844 319.811 214.948 318.707 214.948Z",
    fill: "#454B5D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3274_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.853 181.709H103.226C101.643 181.709 100.376 180.443 100.376 178.86V103.201C100.376 101.618 101.643 100.352 103.226 100.352H122.853C124.436 100.352 125.702 101.618 125.702 103.201V178.86C125.702 180.443 124.436 181.709 122.853 181.709Z",
    fill: "#5C6479"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.04 115.547C115.662 115.547 117.788 113.421 117.788 110.798C117.788 108.176 115.662 106.05 113.04 106.05C110.417 106.05 108.291 108.176 108.291 110.798C108.291 113.421 110.417 115.547 113.04 115.547Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 122.511H104.65C104.334 122.511 104.175 122.353 104.175 122.036V120.77C104.175 120.454 104.334 120.295 104.65 120.295H121.27C121.586 120.295 121.745 120.454 121.745 120.77V122.036C121.903 122.353 121.586 122.511 121.428 122.511Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 129.159H104.65C104.334 129.159 104.175 129.001 104.175 128.684V127.418C104.175 127.101 104.334 126.943 104.65 126.943H121.27C121.586 126.943 121.745 127.101 121.745 127.418V128.684C121.903 129.001 121.586 129.159 121.428 129.159Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 135.807H104.65C104.334 135.807 104.175 135.649 104.175 135.332V134.066C104.175 133.749 104.334 133.591 104.65 133.591H121.27C121.586 133.591 121.745 133.749 121.745 134.066V135.332C121.903 135.649 121.586 135.807 121.428 135.807Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 142.613H104.65C104.334 142.613 104.175 142.455 104.175 142.138V140.872C104.175 140.555 104.334 140.397 104.65 140.397H121.27C121.586 140.397 121.745 140.555 121.745 140.872V142.138C121.903 142.296 121.586 142.613 121.428 142.613Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 149.261H104.65C104.334 149.261 104.175 149.103 104.175 148.786V147.52C104.175 147.203 104.334 147.045 104.65 147.045H121.27C121.586 147.045 121.745 147.203 121.745 147.52V148.786C121.903 148.945 121.586 149.261 121.428 149.261Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.428 155.908H104.65C104.334 155.908 104.175 155.75 104.175 155.434V154.167C104.175 153.851 104.334 153.693 104.65 153.693H121.27C121.586 153.693 121.745 153.851 121.745 154.167V155.434C121.903 155.75 121.586 155.908 121.428 155.908Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.421 162.557H107.816C107.5 162.557 107.341 162.398 107.341 162.082V160.816C107.341 160.499 107.5 160.341 107.816 160.341H118.421C118.738 160.341 118.896 160.499 118.896 160.816V162.082C118.896 162.398 118.579 162.557 118.421 162.557Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.892 170.312H139.631V172.687H181.892V170.312Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.582 176.644H139.631V179.018H162.582V176.644Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.702 170.312H190.44V172.687H232.702V170.312Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.391 176.644H190.44V179.018H213.391V176.644Z",
    fill: "#868EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.893 93.148L188.4 86.4818C190.856 85.9555 193.312 86.4818 195.241 87.7098L221.029 102.621",
    stroke: "#868EA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3274_3072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.66 173.318L135.789 160.512C133.158 160.161 131.404 157.705 131.755 155.074L140.35 93.8496C140.701 91.2181 143.157 89.4639 145.789 89.8147L230.66 102.621C233.291 102.972 235.045 105.428 234.695 108.059L226.099 169.283C225.748 171.739 223.292 173.669 220.66 173.318Z",
    fill: "url(#paint10_linear_3274_3072)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M217.881 166.351L142.013 154.501C139.869 154.215 138.439 152.214 138.725 150.069L145.731 100.168C146.017 98.0236 148.019 96.5938 150.163 96.8797L226.031 108.729C228.176 109.015 229.606 111.017 229.32 113.161L222.314 163.062C222.028 165.064 220.026 166.637 217.881 166.351Z",
    fill: "#2A2E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.308 61.8888L277.179 73.76C277.971 74.5514 279.078 75.0263 280.028 75.0263H309.785V47.1685H263.883V58.8814C264.2 60.1477 264.516 61.0974 265.308 61.8888Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.086 59.8135H304.015C304.567 59.8135 305.015 59.3658 305.015 58.8135V52.7411C305.015 52.1888 304.567 51.7411 304.015 51.7411H292.086C291.534 51.7411 291.086 52.1888 291.086 52.7411V58.8135C291.086 59.3658 291.534 59.8135 292.086 59.8135Z",
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.08 59.8135H286.009C286.561 59.8135 287.009 59.3658 287.009 58.8135V52.7411C287.009 52.1888 286.561 51.7411 286.009 51.7411H274.08C273.528 51.7411 273.08 52.1888 273.08 52.7411V58.8135C273.08 59.3658 273.528 59.8135 274.08 59.8135Z",
    fill: "#414756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08301 241.857H392.058",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.932 240.591H115.564L116.514 238.217L118.73 232.202L120.629 226.979L122.845 220.964L124.428 216.848C124.744 216.057 125.536 215.424 126.327 215.424C127.119 215.424 127.91 215.899 128.227 216.848L129.809 220.964L132.025 226.979L133.925 232.202L136.141 238.217L136.932 240.591Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.031 226.979H120.642L122.782 221.122H129.86L132.031 226.979Z",
    fill: "url(#paint11_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.134 238.217H116.507L118.723 232.202H133.918L136.134 238.217Z",
    fill: "url(#paint12_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.932 240.591H115.405C114.772 240.591 114.139 240.116 114.139 239.325C114.139 238.692 114.614 238.059 115.405 238.059H136.932C137.565 238.059 138.198 238.534 138.198 239.325C138.198 240.116 137.723 240.591 136.932 240.591Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.03 240.591H232.662L233.611 238.217L235.827 232.202L237.727 226.979L239.943 220.964L241.525 216.848C241.842 216.057 242.633 215.424 243.425 215.424C244.216 215.424 245.008 215.899 245.324 216.848L246.907 220.964L249.123 226.979L251.022 232.202L253.238 238.217L254.03 240.591Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.129 226.979H237.739L239.88 221.122H246.958L249.129 226.979Z",
    fill: "url(#paint13_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.232 238.217H233.604L235.82 232.202H251.016L253.232 238.217Z",
    fill: "url(#paint14_linear_3274_3072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.03 240.591H232.503C231.87 240.591 231.237 240.116 231.237 239.325C231.237 238.692 231.712 238.059 232.503 238.059H254.03C254.663 238.059 255.296 238.534 255.296 239.325C255.296 240.116 254.821 240.591 254.03 240.591Z",
    fill: "#5C6479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.966 133.568C169.134 133.847 171.318 132.135 171.732 129.832C172.145 127.529 170.661 125.344 168.493 125.066C166.325 124.787 164.14 126.5 163.727 128.802C163.313 131.105 164.798 133.29 166.966 133.568Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.685 138.389C200.853 138.667 203.038 136.955 203.451 134.652C203.865 132.349 202.38 130.165 200.212 129.886C198.044 129.607 195.86 131.32 195.446 133.623C195.001 136.103 196.517 138.11 198.685 138.389Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.744 115.605L159.8 119.268L160.587 121.598L170.531 117.934L169.744 115.605Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.082 120.299L199.402 122.489L207.652 128.684L209.331 126.493L201.082 120.299Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37 145.647C183.968 145.981 186.376 144.573 186.747 142.503C187.119 140.433 185.314 138.484 182.716 138.149C180.118 137.815 177.711 139.223 177.339 141.293C176.967 143.363 178.772 145.312 181.37 145.647Z",
    fill: "#474E61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.617 256.173H324.892",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2231 256.173H72.7965",
    stroke: "#3D4550",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3274_3072",
    x: 78.376,
    y: 89.352,
    width: 69.326,
    height: 125.357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3274_3072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3274_3072",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3274_3072",
    x: 127.71,
    y: 89.7701,
    width: 111.029,
    height: 91.5892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3274_3072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3274_3072",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3274_3072",
    x1: 171.59,
    y1: 239.818,
    x2: 171.59,
    y2: 212.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#2F3338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3274_3072",
    x1: 171.41,
    y1: 210.341,
    x2: 171.41,
    y2: 99.8618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9913,
    stopColor: "#2F3338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3274_3072",
    x1: 341.552,
    y1: 207.826,
    x2: 341.552,
    y2: 222.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3274_3072",
    x1: 352.473,
    y1: 207.826,
    x2: 352.473,
    y2: 222.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3274_3072",
    x1: 363.395,
    y1: 207.826,
    x2: 363.395,
    y2: 222.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3274_3072",
    x1: 374.316,
    y1: 207.826,
    x2: 374.316,
    y2: 222.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3274_3072",
    x1: 25.4297,
    y1: 203.71,
    x2: 25.4297,
    y2: 220.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3274_3072",
    x1: 37.9341,
    y1: 203.71,
    x2: 37.9341,
    y2: 220.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3274_3072",
    x1: 50.4385,
    y1: 203.71,
    x2: 50.4385,
    y2: 220.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3274_3072",
    x1: 62.9429,
    y1: 203.71,
    x2: 62.9429,
    y2: 220.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3274_3072",
    x1: 155.343,
    y1: 111.712,
    x2: 187.347,
    y2: 178.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3274_3072",
    x1: 129.899,
    y1: 221.122,
    x2: 122.723,
    y2: 221.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3274_3072",
    x1: 132.459,
    y1: 232.202,
    x2: 120.094,
    y2: 232.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3274_3072",
    x1: 246.996,
    y1: 221.122,
    x2: 239.821,
    y2: 221.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3274_3072",
    x1: 249.557,
    y1: 232.202,
    x2: 237.191,
    y2: 232.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C6479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#818AA2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3274_3072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 394,
    height: 258,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWip1);
export default __webpack_public_path__ + "static/media/wip1.09af8c14318676dd1ff6703d4ee4bcdb.svg";
export { ForwardRef as ReactComponent };